export function getSortedResults(hotelData, filterState, sortBy, sortDecreasing) {
  const titleRowNames = filterState.showTelcoDetails
    ? [
        'displayId',
        'shortName',
        'clicks',
        'invited',
        'bookings',
        'conversions',
        'textInbound',
        'textOutbound',
        'optOut',
        'segmentOutbound',
        'segmentInbound',
        'inviteFailedSpam',
        'inviteFailedOther'
      ]
    : [
        'displayId',
        'shortName',
        'clicks',
        'invited',
        'bookings',
        'conversions',
        '',
        'Lost6Months',
        'Lost9Months',
        'Lost12Months',
        'Lost15Months',
        'AfterLastVisit',
        'CheckedOutReview',
        'NoShow',
        'Cancelled'
      ]

  let sortByProp = titleRowNames[sortBy]

  const sortedData = hotelData.sort((a, b) => {
    let valA = a[sortByProp]
    let valB = b[sortByProp]

    if (sortBy > 6 && !filterState.showTelcoDetails) {
      valA = !!a.notificationsActive?.includes(sortByProp)
      valB = !!b.notificationsActive?.includes(sortByProp)
    }

    if (typeof valA === 'string') {
      if (valA === valB) {
        return 0
      }

      return valA.toUpperCase() > valB.toUpperCase()
    } else if (typeof valA === 'object' && valA.periodCurrent) {
      if (valA.periodCurrent === valB.periodCurrent) {
        return 0
      }

      return valB.periodCurrent - valA.periodCurrent
    } else {
      return valB - valA
    }
  })

  return sortDecreasing ? sortedData : sortedData.reverse()
}
